import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import React from "react";
import { Box, Button, Stack, Typography } from "@mui/material";
export var StateMessage = function (_a) {
    var className = _a.className, title = _a.title, message = _a.message, actionLabel = _a.actionLabel, onAction = _a.onAction;
    return (_jsx(Box, { className: ["seq-results-state-message", className].filter(Boolean).join(" "), sx: {
            width: "100%",
            maxWidth: 760,
            mx: "auto",
            my: { xs: 4, md: 8 },
            px: { xs: 2, sm: 3 },
            py: { xs: 4, sm: 5 },
            border: "1px solid",
            borderColor: "divider",
            borderRadius: 1,
            bgcolor: "background.paper",
        }, children: _jsxs(Stack, { className: "seq-results-state-message__content", spacing: 2, alignItems: "flex-start", children: [_jsx(Typography, { className: "seq-results-state-message__title", component: "h1", variant: "h4", children: title }), _jsx(Typography, { className: "seq-results-state-message__message", color: "text.secondary", children: message }), actionLabel && onAction && (_jsx(Button, { className: "seq-results-state-message__action", variant: "contained", onClick: onAction, children: actionLabel }))] }) }));
};
